export const addSize = (
  image: string | undefined,
  width?: number,
  height?: number
) => {
  if (!image) {
    return undefined;
  }

  if (
    image.includes('fit-in') ||
    !width ||
    !height ||
    (!image.includes('/media/image/') &&
      !image.includes('/screenshot/') &&
      !image.includes('/media/cache_image/'))
  ) {
    return image;
  }

  // Détection du devicePixelRatio pour les écrans haute résolution
  const pixelRatio =
    typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
  const adjustedWidth = Math.round(width * pixelRatio);
  const adjustedHeight = Math.round(height * pixelRatio);

  const index = image.includes('/media/image/')
    ? image.indexOf('/media/image/')
    : image.includes('/screenshot/')
      ? image.indexOf('/screenshot/')
      : image.indexOf('/media/cache_image/');

  return (
    image.substring(0, index) +
    `/fit-in/${adjustedWidth}x${adjustedHeight}` +
    image.substring(index, image.length)
  );
};
